import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-none"
}
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = {
  key: 0,
  for: "opening-time",
  class: "mb-1"
}
const _hoisted_4 = { class: "p-field-radiobutton" }
const _hoisted_5 = { for: "CommandSettingsOptionMonostable" }
const _hoisted_6 = { class: "p-field-radiobutton" }
const _hoisted_7 = { for: "CommandSettingsOptionBistable" }
const _hoisted_8 = {
  key: 1,
  class: "p-field-radiobutton"
}
const _hoisted_9 = { for: "CommandSettingsOptionBistableWithBladesControl" }
const _hoisted_10 = {
  key: 2,
  class: "p-field-radiobutton"
}
const _hoisted_11 = { for: "CommandSettingsOptionMonostableAndBistable" }
const _hoisted_12 = {
  key: 3,
  class: "p-field-radiobutton"
}
const _hoisted_13 = { for: "CommandSettingsOptionBladesAndBistable" }
const _hoisted_14 = {
  key: 4,
  class: "mt-5"
}
const _hoisted_15 = { class: "p-field-radiobutton" }
const _hoisted_16 = { for: "CommandSettingsDirectionOptionUp" }
const _hoisted_17 = { class: "p-field-radiobutton" }
const _hoisted_18 = { for: "CommandSettingsDirectionOptionDown" }
const _hoisted_19 = {
  key: 5,
  class: "mt-5"
}
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "mb-0 ml-3" }
const _hoisted_22 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_23 = { class: "fs-12 text-right text-gray mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Slider = _resolveComponent("Slider")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.deviceName)
      ? (_openBlock(), _createBlock("h3", _hoisted_1, _toDisplayString(_ctx.deviceName), 1))
      : _createCommentVNode("", true),
    _createVNode("h5", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.CommandSettings")), 1),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settings.slots, (s, index) => {
      return (_openBlock(), _createBlock("div", {
        key: `slot-${index}`,
        class: "mb-4"
      }, [
        (s.hasMoreThanOneSlotSettings)
          ? (_openBlock(), _createBlock("h6", _hoisted_3, " Slot " + _toDisplayString(index), 1))
          : _createCommentVNode("", true),
        _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.CommandSettingsMode")), 1),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_RadioButton, {
            id: "CommandSettingsOptionMonostable",
            name: "shutterMode",
            value: _ctx.ShutterMode.Monostable,
            modelValue: s.shutterMode,
            "onUpdate:modelValue": ($event: any) => (s.shutterMode = $event),
            disabled: _ctx.readonly
          }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionMonostable")), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_RadioButton, {
            id: "CommandSettingsOptionBistable",
            name: "shutterMode",
            value: _ctx.ShutterMode.Bistable,
            modelValue: s.shutterMode,
            "onUpdate:modelValue": ($event: any) => (s.shutterMode = $event),
            disabled: _ctx.readonly
          }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionBistable")), 1)
        ]),
        (s.showBistableAndBladesControl)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode(_component_RadioButton, {
                id: "CommandSettingsOptionBistableWithBladesControl",
                name: "shutterMode",
                value: _ctx.ShutterMode.BistableWithBladesControl,
                modelValue: s.shutterMode,
                "onUpdate:modelValue": ($event: any) => (s.shutterMode = $event),
                disabled: _ctx.readonly
              }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t(
                            "AppResource.CommandSettingsOptionBistableWithBladesControl"
                        )), 1)
            ]))
          : _createCommentVNode("", true),
        (s.showMonostableAndBistable)
          ? (_openBlock(), _createBlock("div", _hoisted_10, [
              _createVNode(_component_RadioButton, {
                id: "CommandSettingsOptionMonostableAndBistable",
                name: "shutterMode",
                value: _ctx.ShutterMode.MonostableBistable,
                modelValue: s.shutterMode,
                "onUpdate:modelValue": ($event: any) => (s.shutterMode = $event),
                disabled: _ctx.readonly
              }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionMonostableAndBistable")), 1)
            ]))
          : _createCommentVNode("", true),
        (s.showBladesControlAndBistable)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _createVNode(_component_RadioButton, {
                id: "CommandSettingsOptionBladesAndBistable",
                name: "shutterMode",
                value: _ctx.ShutterMode.BladesAndBistable,
                modelValue: s.shutterMode,
                "onUpdate:modelValue": ($event: any) => (s.shutterMode = $event),
                disabled: _ctx.readonly
              }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
              _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("AppResource.CommandSettingsOptionBladesAndBistable")), 1)
            ]))
          : _createCommentVNode("", true),
        (s.showCommandDirection)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode("p", null, _toDisplayString(_ctx.$t("device.commandDirection")), 1),
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_RadioButton, {
                  id: "CommandSettingsDirectionOptionUp",
                  name: "commandDirection",
                  value: _ctx.CommandDirection.Up,
                  modelValue: s.commandDirection,
                  "onUpdate:modelValue": ($event: any) => (s.commandDirection = $event),
                  disabled: _ctx.readonly
                }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("AppResource.Up")), 1)
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_RadioButton, {
                  id: "CommandSettingsDirectionOptionDown",
                  name: "commandDirection",
                  value: _ctx.CommandDirection.Down,
                  modelValue: s.commandDirection,
                  "onUpdate:modelValue": ($event: any) => (s.commandDirection = $event),
                  disabled: _ctx.readonly
                }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("AppResource.Down")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (s.showPreset)
          ? (_openBlock(), _createBlock("div", _hoisted_19, [
              _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.CommandSettingsPreset")), 1),
              _createVNode("div", _hoisted_20, [
                _createVNode(_component_InputSwitch, {
                  modelValue: s.hasPreset,
                  "onUpdate:modelValue": ($event: any) => (s.hasPreset = $event),
                  disabled: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("AppResource.CommandSettingsEnablePreset")), 1)
              ]),
              (s.hasPreset)
                ? (_openBlock(), _createBlock("div", _hoisted_22, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.CommandSettingsPresetValue")), 1),
                    _createVNode(_component_Slider, {
                      modelValue: s.presetValue,
                      "onUpdate:modelValue": ($event: any) => (s.presetValue = $event),
                      orientation: "horizontal",
                      disabled: _ctx.readonly
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                    _createVNode("div", _hoisted_23, _toDisplayString(s.presetValue), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}